<div class="sectionb">

            <nav
                class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
                <span class="navbar-brand mb-0 h1"><i class="fas fa-list"></i> Flights</span> <span class="badge badge-primary">{{dataSource.filteredData.length}} flights</span>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <div class="ml-auto d-flex justify-content-end">
                        <ul class="nav navbar-nav ml-auto">
                            <li *ngIf="uiShowActionBtn(controlEnum.BTN_FLIGHT_NEW)" class="nav-item">
                                <a  class="nav-link" role="button"  (click)="newFlight(null);false">
                                    <i class="far fa-plus-square"></i> New Flight
                                </a>
                            </li>                   
                            <li class="nav-item">
                                <a class="nav-link" role="button" (click)="refresh();false">
                                    <i class="fas fa-sync"></i>
                                </a>
                            </li>
                        </ul>
                        <ul class="nav navbar-nav ml-auto">
                            <li class="nav-item dropdown" dropdown placement="bottom right">
                              <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                                aria-expanded="false" dropdownToggle (click)="false">
                                <i class="fas fa-ellipsis-v"></i>
                              </a>
                              <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown1">                                
                                <a *ngIf="uiShowActionBtn(controlEnum.BTN_FLIGHT_PROCESS_IMAGES)" class="dropdown-item" (click)="supervisionProcessFlights()"><i class="fas fa-cogs"></i> Process all flights</a>
                                <a *ngIf="uiShowActionBtn(controlEnum.BTN_FLIGHT_PROCESS_ISSUES)" class="dropdown-item" (click)="supervisionFindIssues()"><i class="fas fa-search"></i> Find issues </a>
                                
                                <div class="dropdown-header"><strong>Table options</strong></div>
                                <a class="dropdown-item" (click)="table_showHideColumn('offset',1)">Show/Hide OffSet </a>
                                <a class="dropdown-item" (click)="table_showHideColumn('relativealt',2)">Show/Hide Relative Altitude </a>
                              </div>

                            </li>
                          </ul>
                    </div>
                </div>
            </nav>
      
            <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
            <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
            <perfect-scrollbar class="table-perfect-scrollbar">
            <table mat-table #table [dataSource]="dataSource" matSort
                class="table table-hover table-striped frms-table table-align-middle">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-id mat-uuid"> Id </th>
                    <td mat-cell *matCellDef="let row" class="table-header-id mat-uuid">
                        {{row.id}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="flight-badge badge" (click)="showFlight(row)" [style.background]="flightColor(row)"
                        matTooltip="Click to show flight">
                        <app-check-box-icon [checked]="flightIsSelected(row)"></app-check-box-icon> 
                        {{row.name}}                        
                    </span> 
                    </td>
                </ng-container>
                <ng-container matColumnDef="offset">
                    <th mat-header-cell *matHeaderCellDef>OffSet </th>
                    <td mat-cell *matCellDef="let row" class="col-composed">
                        <div>
                            <span class="bold">X: </span>{{row.info?.offset_x}} <span class="bold">Y: </span>{{row.info?.offset_y}} <span class="bold">Z: </span>{{row.info?.offset_z}} 
                        </div>
                       <div>
                        <span class="bold">Camera: </span><span class="bold">Yaw: </span>{{row.info?.offset_camera_yaw}} <span class="bold">Pitch: </span>{{row.info?.offset_camera_pitch}} <span class="bold">Roll: </span>{{row.info?.offset_camera_roll}} 
                        </div>                        
                        
                    </td>
                </ng-container> 
                <ng-container matColumnDef="relativealt">
                    <th mat-header-cell *matHeaderCellDef>Relative Altitude </th>
                    <td mat-cell *matCellDef="let row" class="col-composed">
                        <span class="bold">Max: </span>{{row.info?.max_RelativeAlt}} <span class="bold">Min: </span>{{row.info?.min_RelativeAlt}} 
                    </td>
                </ng-container>                
                <ng-container matColumnDef="creation_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.creation_date | date:'dd-MM-yyyy HH:mm' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                    <td mat-cell *matCellDef="let row">
                        <app-flight-status [status]="row?.info?.status"></app-flight-status>
                    </td>
                </ng-container>  
                <ng-container matColumnDef="modifydate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modify </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.updating_date | date:'dd-MM-yyyy HH:mm' }}
                    </td>
                </ng-container>              
                <!-- Symbol Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()" class="td-actions">
                        <div class="td-displayonhover1 td-actions text-right">
                            <button rel="tooltip" type="button" class="btn btn-sm btn-outline-primary" matTooltip="Show Flight images"
                                (click)="showFlightImages(row)">
                                <i class="far fa-images"></i>
                            </button>
                            <button *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_PROCESS_IMAGES,row)" rel="tooltip" type="button" 
                                    class="btn btn-sm btn-outline-primary"  matTooltip="Process Flight images"
                                   (click)="processFlight(row)">
                                <i class="fas fa-cogs"></i>
                            </button> 
                            <button *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_PROCESS_ISSUES,row)" rel="tooltip" type="button" 
                                class="btn btn-sm btn-outline-primary"  matTooltip="Find issues on processed flight images"                                
                                (click)="flightFindIssues(row)">
                                <i class="fas fa-search"></i>
                            </button>                                                        
                            <button type="button" class="btn btn-sm btn-outline-secondary" [matMenuTriggerFor]="menu"
                                *ngIf="uiShowActionBtn()">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <mat-menu #menu="matMenu" class="">
                                <div mat-menu-item *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_NEW,row)">
                                    <a class="dropdown-item" [routerLink]="" (click)="editFlight(row)" matTooltip="Edit basic data">
                                        <i class="fas fa-pen"></i> Edit</a>
                                </div>                                
                                <div mat-menu-item *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_UPLOADIMAGES,row)">
                                    <a class="dropdown-item" [routerLink]="" (click)="openDialogAddFilesToFlight(row)" matTooltip="Add files to flight">
                                        <i class="fa-plus-square far"></i> Add Files</a>
                                </div>
                                <div mat-menu-item *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_UPLOADIMAGES,row)">
                                    <a class="dropdown-item" [routerLink]="" (click)="projectFlightImages(row)" matTooltip="Project images">
                                        <i class="far fa-images"></i> Project images</a>
                                </div>
                                <div mat-menu-item *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_OPERATOR,row)">
                                    <a class="dropdown-item text-danger" [routerLink]=""
                                        (click)="openDialogDeleteFlightFiles(row)">
                                        <i class="far fa-trash-alt"></i> Delete files
                                    </a>
                                </div>
                                <div mat-menu-item *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_OPERATOR,row)">
                                    <a class="dropdown-item text-danger" [routerLink]=""
                                        (click)="openDialogDeleteFlight(row)">
                                        <i class="far fa-trash-alt"></i> Delete flight
                                    </a>
                                </div>
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" class="thead-dark" ></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" matTooltip="Click to show/hide flight on map."></tr>
            </table>
            </perfect-scrollbar>
    

</div>